import Button from './button';

import { AiFillEye } from 'react-icons/ai';

export default function ButtonView(props) {
    const { 
        children,
     } = props;

    return <Button { ...props } className="button--orange" rightIcon={<AiFillEye style={{ width: '35px', height: '35px', color: 'white' }}/>}>{ children ? children : 'View' }</Button>
}